module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5M1be"))).then(() => module.bundle.root('5erN3'));